import React from 'react'
import {
    Dimmer, Table, Header, Label,
    Feed, Card, Icon,
    Image, Message, List,
    Tab, Divider, Segment,
    Button, Accordion, Transition, Item, Container, Dropdown
} from 'semantic-ui-react'
import { navigateTo } from "gatsby-link"
import utils from '../utils/utils'
import Comments from '../components/Comments'
import ReactDOM from 'react-dom'
import Helmet from 'react-helmet'
import _ from 'lodash'
import SocialMediaTag from '../components/SocialMediaTag'
import StructureData from '../components/StructureData'
import { Course } from '../components/StructureData'
import { slash, arrayToURL, toSlug } from '../utils/utils'

const MainSection = ({cname, intake, fee, duration, overview, qualification, major}) => {
    return <Item>
      <Header textAlign='center' as='h1' size='medium'>{cname.toUpperCase()}</Header>
      <Image src='/covers/university/university-course-banner.jpg' />
      <Divider hidden/>
      <Item.Meta>
        <span>
          <Icon name='calendar plus'/>{intake}
        </span>
        <span> <Icon name='ellipsis vertical' /> </span>
        <span>
          <Icon name='time' />{duration.fulltime} Year
        </span>
        <span> <Icon name='ellipsis vertical' /> </span>
        <span>
          <Icon name='dollar' />{fee.local.total}
        </span>
        <span> <Icon name='ellipsis vertical' /> </span>
        <span>
          <Icon name='student' />{qualification}
        </span>
      </Item.Meta>
      <Divider hidden/>
      <Header as='h3' size='medium'>WHAT CAN I LEARN?</Header>
      <Header as='h2' size='medium' hidden>WHAT CAN I LEARN FROM {cname}</Header>
      <Header as='h2' size='medium' hidden>WHAT CAN I LEARN FROM {major}</Header>

      <Item.Description>{overview}</Item.Description>
    </Item>
}

const Requirement = ({reqs}) => {
   return <div>
    <Header as='h2' size='medium'>REQUIREMENT</Header>
    <Table celled unstackable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Certification</Table.HeaderCell>
          <Table.HeaderCell>Requirement</Table.HeaderCell>
        </Table.Row>
    </Table.Header>
    <Table.Body>
    {reqs.map(({cert, req}) => {
      return  <Table.Row>
        <Table.Cell>{cert}</Table.Cell>
        <Table.Cell>{req}</Table.Cell>
      </Table.Row>
    })}
    </Table.Body>
    </Table>
   </div>
}

const MoreDetails = ({uname}) => {
  const uslug = toSlug(uname);
  return <Container textAlign="center">
  <Button size='small' basic color='grey' onClick={() => {navigateTo(uslug)}}>
   <a style={{display:'none'}} href={slash(uslug)}>{uname} Information</a>
   <Icon name='info' />{uname} Info</Button>
   </Container>
}

const CourseOverview = ({category}) => {
  const cat = _.capitalize(category);
  return <Button size='small' basic color='grey' onClick={() => {navigateTo(category)}}>
   <a style={{display:'none'}} href={slash(category)}>{category} Information</a>
  <Icon name='idea' />Course Overview</Button>
}


const navTo = (url) => {
    navigateTo(url);
}

  const Scholarship = ({scholarships, ctx}) => {
    const handleClick = ctx.handleClick;
    const activeIndex = ctx.state.activeIndex;
    return <Accordion>
      {scholarships.map(({details, headline}, idx) => {
      return <div>
        <Accordion.Title active={activeIndex === idx} index={idx} onClick={handleClick}>
        <Label size='large' >
         <Icon name='dropdown' />{headline}
         </Label>
        </Accordion.Title>
        <Accordion.Content active={activeIndex === idx}>
           <Table celled stackable striped>
             <Table.Body>
             {details.map(({key, value}, idx) => {
              return  <Table.Row>
                 <Table.Cell>{key}</Table.Cell>
                 <Table.Cell>{value.split('•').map((p) =>(<p>{p}</p>))}</Table.Cell>
               </Table.Row>
             })}
             </Table.Body>
          </Table>
       </Accordion.Content>
        </div>
      })}
    </Accordion>
  }

  const FeeStructure = ({fee}) => {
    if(! fee) {
      return <div />
    }

    return <Table structured celled unstackable>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell colSpan='2'>Type</Table.HeaderCell>
        <Table.HeaderCell>Fee</Table.HeaderCell>
      </Table.Row>
    </Table.Header>
    <Table.Body>
    { fee.local &&
      <Table.Row>
        <Table.Cell rowSpan='2'>Local Student</Table.Cell>
        <Table.Cell>Average Per Year</Table.Cell>
        <Table.Cell>{fee.local.average}</Table.Cell>
      </Table.Row>
    }
    { fee.local &&
      <Table.Row>
        <Table.Cell>Total Cost</Table.Cell>
        <Table.Cell>{fee.local.total}</Table.Cell>
      </Table.Row>
    }
    { fee.international &&
      <Table.Row>
        <Table.Cell rowSpan='2'>International Student</Table.Cell>
        <Table.Cell>Average Per Year</Table.Cell>
        <Table.Cell>{fee.international.average}</Table.Cell>
      </Table.Row>
    }
    { fee.international &&
      <Table.Row>
        <Table.Cell>Total Cost</Table.Cell>
        <Table.Cell>{fee.international.total}</Table.Cell>
      </Table.Row>
    }
      </Table.Body>
    </Table>
  }

  const Career = ({careers}) => {

    const navTo = ({url}) => {
      navigateTo(url)
    }

    return <div>
    <Header as='h2' size='medium'>CAREER PROSPECTS</Header>
    <Label.Group key='careers' size='small'>
      {careers.map((career) => {
        const url = slash(toSlug(career));
        return <Label as='a' onClick={() => navTo({url})}>
          {career}
        </Label>
      })}
      </Label.Group>
      </div>
  }
  //TODO fix this
  const OtherMajor = ({majors, uname}) => {
    const uslug = toSlug(uname);
    return <Container textAlign="center">
       <List divided horizontal size="small">
         {majors.map((major, i) => {
            return <List.Item key={i}>
            <a href={slash(arrayToURL([uslug]))}>{major}</a>
            </List.Item>
         })}
       </List>
      {majors.map((major, i) => {
        return <a key={i} style={{display:'none'}} href={slash(arrayToURL([uslug]))}>{major} in {uname}</a>
      })}
    </Container>
  }


  const Similarity = ({otherUniversities, major}) => {

    if(! otherUniversities || ! otherUniversities.group
      || ! otherUniversities.group.length === 0) {
        return <div/>
    }
    const universities = otherUniversities.group;
    return <Container textAlign="center">
      <List divided horizontal size="small">
        {universities.map(({university}, i) => {
           return <List.Item key={i}>
            <a key={i} href={slash(toSlug(university))}>{university}</a>
           </List.Item>
        })}
      </List>
      {universities.map(({university}, i) => {
        return <a key={i} style={{display:'none'}} href={slash(toSlug(university))}>{major} in {university}</a>
      })}
      <Divider hidden/>
    </Container>
  }



class CourseDetails extends React.Component {

  state = { activeIndex: -1 }


  constructor(props) {
    super(props);
    /*
    this.state = {
      active: true,
      tooltip: true,
    }
    */
  }
  componentDidMount() {

    ReactDOM.findDOMNode(this.props.top).scrollIntoView();

    //TODO: Grey out
    /*
    setTimeout(() => {
      _this.setState((state, props) => {
        state.active = false;
      })
    }, 500);

    setTimeout(() => {
      _this.setState((state, props) => {
        state.tooltip = false;
      })
    }, 2500);
    */
    if(typeof FB !== "undefined") {
      FB.XFBML.parse();
    }
  }

  render() {

    this.handleClick = (e, titleProps) => {
      const { index } = titleProps
      const { activeIndex } = this.state
      const newIndex = activeIndex === index ? -1 : index
      this.setState({ activeIndex: newIndex })
    }
    const { activeIndex } = this.state
    const path = this.props.location.pathname;
    //TODO: Grey out
    //const { detail } = this.props.pathContext;
    const {
      university,
      study_field,
      major,
      title,
      about,
      duration,
      qualification,
      intakes,
      photo,
      careers,
      scholarships,
      requirements,
      fee
    } = this.props.pathContext;
    const majors = this.props.data.majors;
    const meta = this.props.data.meta;
    const sameMajorDiffUni = this.props.data.sameMajorDiffUni;
    /*
    otherCourses = otherCourses.filter((x) => {
        return x.course !== course;
    });
    */
    //const { active, tooltip } = this.state;
    const pageTitle = `Know more about ${title} in ${university} | Uni Village Education`
    const description = `You will get the insights on ${title} which offers by ${university}.` +
       `Such as course requirement/eligibility, course duration, study fee and intake.`
    const courseMeta = Course(title, about, university);
    const whatIs = meta && meta.edges[0].node.description;

    return <div>
        <Helmet>
            <title>{pageTitle}</title>
            <meta name="description" content={about} />
        </Helmet>
        <SocialMediaTag type="article"
          image={`${process.env.URL}/covers/course-overview/accounting.jpg`}
          title={pageTitle}
          url={path}
          description={about}
        />
        <StructureData meta={courseMeta} />
        {/*tooltip && <Transition animation='scale' duration={1000} visible={tooltip}>
          <Header as='h4' icon textAlign='center' disabled>
            <Icon name='magnet' loading />
            {title} Information
          </Header>
        </Transition>*/}
        <div>
        <MainSection cname={title} overview={about} fee={fee}
          duration={duration} intake={intakes}
          qualification={qualification} major={major} />
        <Divider />

        {whatIs && <div><Header as='h2' size='medium'>WHAT IS {major.toUpperCase()}?</Header>
          {whatIs}
        <Divider />
        </div>
        }
        <Requirement reqs={requirements} />
        <Divider />

        { scholarships && scholarships.length >0 &&
        <div>
        <Header as='h2' size='medium'>SCHOLARSHIPS</Header>
        <Scholarship scholarships={scholarships} ctx={this} />
        <Divider />
        </div>
        }

        <Header as='h2' size='medium'>FEE STRUCTURE</Header>
        <FeeStructure fee={fee} />
        { careers && careers.length >0 &&
        <Career careers={careers} />
        }

        <Divider hidden />
        {majors.distinct &&
          <div>
          <Header as='h2' size='medium'>COURSES IN {university.toUpperCase()}</Header>
          <OtherMajor majors={majors.distinct} uname={university} />
          </div>
        }
        <Divider hidden />
        {sameMajorDiffUni &&
          <div>
          <Header as='h3' size='medium'>{major.toUpperCase()} COURSE IN OTHER UNIVERSITY</Header>
          <Similarity otherUniversities={sameMajorDiffUni} major={major} />
          </div>
        }
        <Divider hidden />
        <MoreDetails uname={university}/>
        <Divider hidden />
        </div>
      <Comments path={path} />
    </div>
  }
}

export const pageQuery = graphql`
  query Courses($university:String!, $major: String!){

    majors: allCourseMajorJson(filter:{
      university: { eq: $university} }) {
      distinct(field: major)
    }

    courses: allCourseDetailsJson(filter:{
      university: { eq: $university} }) {
      edges {
        node {
          title
          university
        }
      }
    }

    meta: allStudyFieldMetadataJson(filter: { major: { eq: $major } }) {
      edges {
        node {
          description
        }
      }
    }

    sameMajorDiffUni: allCourseMajorJson(filter: {
      university : {ne: $university },
      major: {eq: $major}
    }) {
   		group(field:university) {
        university:fieldValue
      }
    }

}`



export default CourseDetails;



// WEBPACK FOOTER //
// ./src/templates/course-details.js